<template>
  <div class="sub-page">
    <div class="btn-close">
      <Icon type="ios-close-circle-outline" @click="cancel" />
    </div>
    <div class="sub-page-bd">
      <Form ref="form" :model="formData" :rules="rule" :label-width="120">
        <Row>
          <Col span="12">
            <FormItem :label="$t('org_level')" prop="org_level">
              <Select
                :disabled="org_level_disabled"
                v-model="formData.org_level"
                @on-change="onLevelChange"
              >
                <Option :value="item.key" v-for="item in org_levels" :key="item.key">{{item.value}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('sort')" prop="sort_id">
              <Input v-model="formData.sort_id" :placeholder="$t('input')"></Input>
            </FormItem>
          </Col>
        </Row>
        <FormItem :label="$t('mod_cname')" prop="mod_cname">
          <Input v-model="formData.mod_cname" :placeholder="$t('input')"></Input>
        </FormItem>
        <FormItem :label="$t('mod_cdesc')" prop="mod_cdesc">
          <Input
            v-model="formData.mod_cdesc"
            type="textarea"
            :autosize="{minRows: 2,maxRows: 3}"
            :placeholder="$t('input')"
          ></Input>
        </FormItem>
        <Row>
          <Col span="12">
            <FormItem :label="$t('add_user')">
              <Input v-model="formData.add_user" disabled></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('add_time')">
              <Input v-model="formData.add_time" disabled></Input>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem :label="$t('upd_user')">
              <Input v-model="formData.upd_user" disabled></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label="$t('upd_time')">
              <Input v-model="formData.upd_time" disabled></Input>
            </FormItem>
          </Col>
        </Row>
        <FormItem :label="$t('select_func')">
          <Tree class="tree-edit" ref="tree" :data="listData" show-checkbox multiple></Tree>
        </FormItem>
      </Form>
    </div>
    <div class="sub-page-ft">
      <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
      <Button type="primary" @click="submit">{{$t('save')}}</Button>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      relist: false,
      op: this.$base.getRequest().op,
      org_levels: [],
      formData: {
        mod_id: '',
        mod_cname: '',
        mod_cdesc: '',
        org_level: '',
        sort_id: 99,
        funcs: [],
        add_user: '',
        add_time: '',
        upd_user: '',
        upd_time: '',
      },
      listData: [],
      rule: {
        mod_cname: [{ required: true, message: this.$t('input'), trigger: 'blur' }],
        // mod_cdesc: [{required: true, message: this.$t('input'), trigger: 'blur'}],
        org_level: [{ required: true, message: this.$t('select'), trigger: 'change' }],
        sort_id: [{ required: true, pattern: this.$base.regNum(), message: this.$t('input'), trigger: 'blur' }],
      }
    }
  },
  computed: {
    org_level_disabled: function () {
      return this.op == 'upd' ? true : false;
    }
  },
  mounted: function () {
    this.$parent.$parent.show_subview = true;
    if (this.$base.getRequest().op == 'add') {
      this.getLoad();
    }
    else {
      this.formData = JSON.parse(this.$base.getRequest().item)
      this.getInfo();
    }
  },
  methods: {
    onLevelChange (val) {
      this.$request.sendPost("mod/get-add-funcs", { org_level: val }, (success, data, error) => {
        this.$base.hideLoading();
        if (success) {
          this.listData = data.funcs
        }
        else {
          this.$base.alertErr(error.errmsg);
        }
      });
    },
    cancel: function () {
      this.$base.linkBack();
    },
    getLoad: function () {
      this.$base.showLoading();
      this.$request.sendPost("mod/before-add", {}, (success, data, error) => {
        this.$base.hideLoading();
        if (success) {
          this.org_levels = this.org_levels.concat(data.org_level);
          this.listData = data.funcs;
        }
        else {
          this.$base.alertErr(error.errmsg);
        }
      });
    },
    getInfo: function () {
      var id = this.formData.mod_id;
      if (!id) {
        return;
      }
      var data = {
        mod_id: id
      };
      this.$base.showLoading();
      this.$request.sendPost("mod/before-upd", data, (success, data, error) => {
        this.$base.hideLoading();
        if (success) {
          this.org_levels = this.org_levels.concat(data.org_level);
          this.listData = data.funcs;
        }
        else {
          this.$base.alertErr(error.errmsg);
        }
      });
    },
    submit: function () {
      this.formData.funcs = [];
      var check_data = this.$refs["tree"].getCheckedNodes();
      check_data.map(item => {
        if (item.func_type && item.func_type == 'P') {
          this.formData.funcs.push(item.func_id)
        }
      });
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var url = this.op == 'upd' ? "mod/upd" : "mod/add";
          this.$base.showLoading();
          this.$request.sendPost(url, this.formData, (success, data, error) => {
            this.$base.hideLoading();
            if (success) {
              this.$base.alertSuccess(error.errmsg);
              this.relist = true;
              this.$base.linkBack();
            }
            else {
              this.$base.alertErr(error.errmsg);
            }
          });
        } else {
          this.$base.alertErr(this.$t('incomplete'));
        }
      })
    }
  },
  beforeDestroy: function () {
    this.$parent.$parent.show_subview = false;
    this.$parent.$parent.relist = this.relist;
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/system/mod_save.vue